import { render, staticRenderFns } from "./pm-welcome-screen.vue?vue&type=template&id=2935bd7c&"
import script from "./pm-welcome-screen.vue?vue&type=script&lang=js&"
export * from "./pm-welcome-screen.vue?vue&type=script&lang=js&"
import style0 from "./pm-welcome-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports